import React from 'react'

export default function pngFolder(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 36">
        <g>
          <path
            fill="#7719AA"
            d="M30.32 9.39v21.7c0 1.68-1.4 2.99-2.99 2.99H6.65c-1.68 0-2.99-1.4-2.99-2.99V4.9c0-1.68 1.31-3.09 2.99-3.09h16.09c.47 0 1.03.19 1.31.56l5.71 5.61c.28.37.56.84.56 1.4v.01Z"
            className="st1"
            opacity=".1"
          />
          <g class="Group">
            <path
              fill="#E2E1DE"
              d="M24.6 16.95H10.28v12.2H24.6v-12.2Z"
              className="st2"
            />
            <path
              fill="#7719AA"
              fill-opacity=".46"
              d="M12.33 16.95h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Zm4.1 0h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              fill-opacity=".46"
              d="M14.38 18.98h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Zm-10.23 2.04h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Zm4.1 0h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              fill-opacity=".46"
              d="M14.38 23.05h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Zm-10.23 2.03h-2.05v2.04h2.05v-2.04Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              fill-opacity=".46"
              d="M16.42 25.08h-2.05v2.04h2.05v-2.04Zm4.1 0h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Zm-10.23 2.04h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Zm4.09 0h-2.05v2.04h2.05v-2.04Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M17.44 24.29c.574 0 1.04-.461 1.04-1.03s-.466-1.03-1.04-1.03c-.575 0-1.04.461-1.04 1.03s.466 1.03 1.04 1.03Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M18.47 19.64c.01-.57-.44-1.04-1.01-1.05-.57-.01-1.05.44-1.06 1v.05c0 .57.46 2.59 1.04 2.59.58 0 1.04-2.02 1.04-2.59h-.01Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M16.78 22.48c.44-.37-.52-2.21-.88-2.64-.36-.45-1.01-.52-1.46-.16-.45.36-.52 1-.16 1.45 0 .01.02.02.03.04.37.44 2.03 1.69 2.47 1.32v-.01Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M16.42 23.09c.1-.56-1.83-1.36-2.39-1.46-.56-.1-1.1.28-1.2.83-.1.55.28 1.1.84 1.19.56.09 2.64 0 2.74-.57h.01v.01Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M16.55 23.78c-.28-.49-2.28.12-2.77.4-.5.27-.7.89-.43 1.39.27.5.9.69 1.4.42a.21.21 0 0 0 .06-.04c.5-.28 2.03-1.7 1.74-2.18v.01Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M17.09 24.23c-.54-.19-1.67 1.55-1.86 2.09-.19.54.08 1.12.62 1.32.54.2 1.13-.08 1.32-.62.2-.54.45-2.59-.08-2.79Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M17.8 24.23c-.54.2-.28 2.26-.08 2.79.19.54.79.81 1.32.62.54-.19.81-.78.62-1.32-.19-.54-1.33-2.28-1.86-2.09Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M21.11 24.19c-.5-.28-2.49-.9-2.77-.4-.28.5 1.24 1.9 1.74 2.18.49.3 1.12.14 1.42-.34.3-.49.14-1.12-.34-1.41-.01 0-.03-.01-.04-.03h-.01Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M22.05 22.46c-.1-.56-.63-.93-1.2-.83-.56.1-2.49.9-2.39 1.46.1.56 2.18.66 2.74.57.56-.1.94-.63.84-1.19h.01v-.01Z"
              className="st1"
            />
            <path
              fill="#7719AA"
              d="M18.1 22.48c.44.37 2.1-.89 2.47-1.32a1.035 1.035 0 0 0-1.59-1.32c-.37.43-1.32 2.28-.88 2.64Z"
              className="st1"
            />
          </g>
          <path
            fill="#7719AA"
            d="m30.7 7.48-5.99-5.8c-.28-.37-.84-.56-1.31-.56H6.56A3.15 3.15 0 0 0 3.38 4.3v27.32c0 1.78 1.4 3.18 3.18 3.18h21.61c1.78 0 3.18-1.4 3.18-3.09V9.07c.09-.65-.19-1.22-.65-1.59Zm-.47 23.29c0 1.59-1.31 2.99-2.9 2.99H7.4c-1.59 0-2.9-1.31-2.9-2.99V5.14c0-1.59 1.31-2.99 2.9-2.99h15.44c.47 0 .94.19 1.31.56l5.52 5.43c.37.37.65.94.56 1.5v21.14-.01Z"
            className="st1"
          />
          <path
            fill="#7719AA"
            d="M1.61 4.85h15.66c.51 0 .92.42.92.96v6.01c0 .53-.41.96-.92.96H.69V5.82c0-.53.41-.94.92-.94v-.03Z"
            className="st1"
          />
          <path
            fill="#9B5EA6"
            d="M18.12 11.68v.12c0 .53-.41.96-.92.96H.63V5.8c0-.53.41-.96.92-.96h.48v2.47c0 2.41 1.87 4.37 4.2 4.37h11.9-.01Z"
            className="st3"
          />
          <path
            fill="#9B5EA6"
            d="m.63 12.76 2.78 3.27v-3.27H.63Z"
            class="Vector"
            className="st3"
          />
          <g class="Group">
            <path
              fill="#F1F2F2"
              d="M4.446 10V6.074H5.84c.29 0 .553.04.79.121.237.08.428.213.573.398.145.185.217.44.217.766 0 .313-.072.57-.217.772-.14.197-.33.343-.567.44a2.107 2.107 0 0 1-.772.139h-.452V10h-.965Zm.965-2.05h.404c.225 0 .392-.05.5-.15.11-.105.163-.252.163-.441 0-.193-.06-.328-.18-.404-.117-.077-.286-.115-.507-.115h-.38v1.11ZM8.074 10V6.074h1l.935 1.846c.069.132.133.275.193.428.065.149.127.3.187.452h.024l-.078-.712a7.12 7.12 0 0 1-.042-.747V6.074h.916V10h-.995l-.94-1.84a8.894 8.894 0 0 1-.193-.427 21.937 21.937 0 0 1-.187-.459H8.87l.078.718c.032.257.048.505.048.742V10h-.922Zm5.812.072c-.366 0-.697-.074-.995-.223a1.673 1.673 0 0 1-.7-.67c-.172-.3-.259-.672-.259-1.115 0-.33.05-.62.151-.874a1.94 1.94 0 0 1 .422-.651 1.78 1.78 0 0 1 .621-.398c.234-.093.48-.139.742-.139a1.697 1.697 0 0 1 1.26.513l-.506.585a1.009 1.009 0 0 0-.314-.2 1.094 1.094 0 0 0-.41-.066.93.93 0 0 0-.856.555c-.08.177-.12.39-.12.64 0 .256.038.476.114.656.076.181.193.32.35.417a1.182 1.182 0 0 0 .796.114.55.55 0 0 0 .162-.066v-.615h-.614V7.75h1.465v1.845a1.599 1.599 0 0 1-.549.338 2.043 2.043 0 0 1-.76.138Z"
              class=".png"
            />
          </g>
        </g>
      </svg>
    </div>
  )
}
